import { useAudioTrack, useVideoTrack } from '@daily-co/daily-react'
import { type MediaTrackState } from '@daily-co/daily-react/dist/hooks/useMediaTrack'
import { useMemo } from 'react'

function trackIsReallyOn(track?: MediaTrackState | null) {
  if (!track) return false
  // It’s “on” only when the state is 'playable' (for remote) or 'sendable' (for local).
  return track.state === 'playable' || track.state === 'sendable'
}

export function useMediaTrackState(sessionId: string | undefined) {
  const audioTrack = useAudioTrack(sessionId ?? '')
  const videoTrack = useVideoTrack(sessionId ?? '')

  return useMemo(
    () => ({
      isAudioTrackOn: trackIsReallyOn(audioTrack),
      isVideoTrackOn: trackIsReallyOn(videoTrack),
    }),
    [audioTrack, videoTrack],
  )
}
